export default "__VITE_ASSET__C7DV3tCQ__"